import { render, staticRenderFns } from "./Minimal.vue?vue&type=template&id=4392efff&scoped=true&"
import script from "./Minimal.vue?vue&type=script&lang=js&"
export * from "./Minimal.vue?vue&type=script&lang=js&"
import style0 from "theme/css/main.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./Minimal.vue?vue&type=style&index=1&id=4392efff&lang=scss&scoped=true&"
import style2 from "./Minimal.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4392efff",
  null
  
)

export default component.exports